import React from 'react';

export default function Completed(props) {
    return <div style={{marginBottom: 20}}>Your ghost event has been completed</div>
}